import { Component, OnInit } from '@angular/core';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'ew-make-payment',
  templateUrl: './make-payment.component.html',
  styleUrls: ['./make-payment.component.scss'],
})
export class MakePaymentComponent implements OnInit {
  providers: any[] = [];
  provider: any;

  currencies: any[] = [];

  bookings: any[] = [
    { id: '#343435434', student: 'Gregorio Nieto', price: '-14,000.00 CAD' },
    { id: '#000013490', student: 'Nicolas Miller', price: '-1,074.00 CAD' },
  ];
  booking: any;
  currencySelected: any;

  constructor(private API: ApiService) {
    this.API.getJson('providers').subscribe((data: any) => {
      this.providers = data.data;
    });
    this.API.getJson('currencies').subscribe((data: any) => {
      this.currencies = data.data;
    });
  }

  ngOnInit(): void {}
}
